import styled from 'styled-components';

export const ListsStyled = styled.div`
  .lists {
    &__container {
      box-sizing: border-box;
      background-color: var(--color-sonata-secondary-300);
      display: flex;
      flex-direction: column;
      flex-shrink: 0;
      gap: 16px;
      padding: 16px;
      width: 338px;
      box-shadow: 0px 4px 28px 0px rgba(111, 104, 150, 0.15);
      min-height: 100%;
      max-height: 100%;
      overflow: hidden;
    }
  }
`;
